import { AspectRatio } from '~/MathTopics/types/math-topic.type'

export function getGameUrl(type: string): string {
  switch (type) {
    case 'multgame':
      return '/games/multgame'
    case 'treasureTrail':
      return '/games/treasure-trail'
    case 'windSurfer':
      return '/games/windsurfer'
    case 'stacknload':
      return '/games/stacknload'
    default:
      return ''
  }
}

export function getTopicBgColor(topicId: string, gradient?: boolean): string {
  let bgColor = gradient ? `bg-gradient-t-to-b-algebra` : 'bg-blue-blueberry'
  if (topicId === 'geometry') {
    bgColor = gradient ? `bg-gradient-t-to-b-geometry` : 'bg-blue-medium-slate'
  } else if (topicId === 'numbersAndQuantities' || topicId === 'numbers-and-quantities') {
    bgColor = gradient ? `bg-gradient-t-to-b-numbers-and-quantities` : 'bg-orchid-dark'
  } else if (topicId === 'statisticsAndProbability' || topicId === 'statistics-and-probability') {
    bgColor = gradient ? `bg-gradient-t-to-b-statistics-and-probability` : 'bg-pink-deep'
  } else if (topicId === 'functions') {
    bgColor = gradient ? `bg-gradient-t-to-b-functions` : 'bg-orange-portland'
  } else if (topicId === 'proofs') {
    bgColor = gradient ? `bg-gradient-t-to-b-proofs` : 'bg-orange-fulvous'
  }
  return bgColor
}

export function getAspectRatio(topicIdOrProductId: string): AspectRatio {
  const aspectRatio: AspectRatio = {
    width: 300,
    height: 300,
  }

  switch (topicIdOrProductId) {
    case 'algebra':
      aspectRatio.width = 362
      aspectRatio.height = 368
      break
    case 'geometry':
      aspectRatio.width = 372
      aspectRatio.height = 312
      break
    case 'numbersAndQuantities':
      aspectRatio.width = 408
      aspectRatio.height = 294
      break
    case 'statisticsAndProbability':
      aspectRatio.width = 348
      aspectRatio.height = 252
      break
    case 'functions':
      aspectRatio.width = 399
      aspectRatio.height = 249
      break
    case 'proofs':
      aspectRatio.width = 396
      aspectRatio.height = 285
      break
    case 'bootcamp':
      aspectRatio.width = 129
      aspectRatio.height = 126
      break
    case 'mathVault':
      aspectRatio.width = 114
      aspectRatio.height = 123
      break
    case 'mathEssential':
      aspectRatio.width = 133
      aspectRatio.height = 82
      break
    case 'encyclopedia':
      aspectRatio.width = 135
      aspectRatio.height = 116
      break
    case 'games':
      aspectRatio.width = 130
      aspectRatio.height = 115
      break
    case 'multgame':
      aspectRatio.width = 351
      aspectRatio.height = 351
      break
    case 'stacknload':
      aspectRatio.width = 416
      aspectRatio.height = 380
      break
    case 'treasureTrail':
      aspectRatio.width = 554
      aspectRatio.height = 342
      break
    case 'windSurfer':
      aspectRatio.width = 484
      aspectRatio.height = 347
      break
    default:
      break
  }

  return aspectRatio
}
